import React, { useState, useEffect } from 'react';

import {} from 'react-bootstrap';
import { useHistory } from 'react-router-dom';

import DepartementService from 'Services/DepartementService';

const Apps = (props) => {
    const history = useHistory();
    const {
        match: { params },
    } = props;
    const [departement, setDepartement] = useState(null);

    useEffect(() => {
        if (params.departementId) {
            DepartementService.getDepartementById(params.departementId)
                .then((result) => {
                    if (result.status === 200) {
                        setDepartement(result.data);
                    }
                })
                .catch((e) => {
                    console.log(e);
                });
        }
    }, [params]);

    const onDelete = () => {
        DepartementService.deleteDepartement(departement)
            .then((result) => {
                if (result.status === 200) {
                    history.push('/admin/departement/index');
                }
            })
            .catch((e) => {
                console.log(e);
            });
    };

    return (
        <>
            <div className="row py-3">
                <div className="col text-center">
                    <h2 className="mb-0">Delete Departement</h2>
                    <i style={{ fontSize: '8pt', fontStyle: 'unset' }}>{departement && departement.nom}</i>
                </div>
            </div>
            <div className="row">
                <div className="col-md-3"></div>
                <div className="col-md-6 d-flex flex-column align-items-center">
                    <img src="/images/alert.svg" alt="" style={{ width: '100pt' }} className="d-block" />
                    <h4 className="py-3">Irreversible Action</h4>
                    <button className="btn btn-danger" onClick={onDelete}>
                        Delete {departement && departement.nom}
                    </button>
                </div>
                <div className="col-md-3"></div>
            </div>
        </>
    );
};

export default Apps;
